import { createSlice } from '@reduxjs/toolkit';
import { clearPickingListFilters } from '../../helpers/pickingListFiltersStorage';
import { clearStocktakeListFilters } from '../../helpers/stocktakeListFiltersStorage';

const getFromLocalStorage = () => {
  let authData;
  try {
    authData = JSON.parse(localStorage.getItem('authData'));
  } catch (error) {
    authData = null;
  }
  return authData;
}

const saveToLocalStorage = (authData) => {
  localStorage.setItem('authData', JSON.stringify(authData));
}

const removeFromLocalStorage = () => {
  localStorage.removeItem('authData');
};

const getInitialStateData = () => {
  const authData = getFromLocalStorage();
  if (!authData) {
    return {
      isAuthenticated: false,
      user: null,
    };
  }
  return authData;
}

const initialState = getInitialStateData();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      clearPickingListFilters();
      clearStocktakeListFilters();
      state.isAuthenticated = true;
      state.user = action.payload;
      saveToLocalStorage({ isAuthenticated: true, user: action.payload });
    },
    logout(state) {
      clearPickingListFilters();
      clearStocktakeListFilters();
      state.isAuthenticated = false;
      state.user = null;
      removeFromLocalStorage();
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;